/**
 * @type {Map<string, (()=>Element)[]}
 */
const map = new Map();

/**
 * @param {string} key
 */
const createValidator = key => () => {
	const tests = map.get(key);

	if (!tests) {
		return [];
	}

	return tests.filter(elementProvider => !elementProvider()?.checkValidity() ?? true);
};

/**
 * Creates a validator function which returns an array of invalid elements.
 * @param {string} key
 */
export const subscribeToValidatorKey = key => {
	return createValidator(key);
};

/**
 * Add your element to the tests array.
 * @param {string} key
 * @param {()=>Element} elementProvider
 */
export const provideValidatorTest = (key, elementProvider) => {
	const tests = map.get(key) || [];

	map.set(key, tests.concat([elementProvider]));
};
